/* this is for parcel */
import "babel-polyfill";
import "./styles/main.scss";
import "./scripts/main.js";
